import _objectSpread from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.map.js";
import "core-js/modules/es.map.get-or-insert.js";
import "core-js/modules/es.map.get-or-insert-computed.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.btoa.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.dom-exception.constructor.js";
import "core-js/modules/web.dom-exception.stack.js";
import "core-js/modules/web.dom-exception.to-string-tag.js";
import axios from "axios";
import { get } from "lodash";
import util from "@/libs/util";
import { errorLog, errorCreate } from "./tools";
import md5 from "js-md5";

// 跨域认证信息 header 名
var xsrfHeaderName = "Authorization";

// axios.defaults.timeout = 10000;
// axios.defaults.withCredentials = true; // 跨域携带cookie
axios.defaults.xsrfHeaderName = xsrfHeaderName;
axios.defaults.xsrfCookieName = xsrfHeaderName;

// 创建一个用于存储当前活跃请求的 Map
var activeRequests = new Map();

// 定义一个函数来取消特定标识符的请求
function cancelRequest(identifier) {
  if (activeRequests.has(identifier)) {
    var cancel = activeRequests.get(identifier);
    cancel('CANCELED');
    activeRequests.delete(identifier);
  }
}

/**
 * @description 创建请求实例
 */
function createService() {
  // 创建一个 axios 实例
  var service = axios.create();

  // 请求拦截
  service.interceptors.request.use(function (config) {
    // 这里你需要根据请求的配置生成一个唯一标识符
    // 例如，使用 config.url 加上可能的 params 序列化结果
    // const identifier = `${config.url}?${new URLSearchParams(config.params || {}).toString()}`;
    var notBlockList = ['/api/v3/admin/im/getRiskByKeyword', '/api/v3/admin/analysis/dwChart', '/api/v3/admin/user/getInfoByIds', '/api/v1/admin/device/list', '/api/v3/admin/operation/log/report'];
    var identifier = "".concat(config.url.toString());
    // 取消之前的相同请求
    if (!notBlockList.includes(identifier)) cancelRequest(identifier);

    // 添加当前请求到 activeRequests Map
    if (config.cancelToken === undefined) {
      config.cancelToken = new axios.CancelToken(function (cancel) {
        if (!activeRequests.has(identifier)) {
          activeRequests.set(identifier, cancel);
        }
      });
    }
    return config;
  }, function (error) {
    // 发送失败
    console.log(error);
    return Promise.reject(error);
  });
  // 响应拦截
  service.interceptors.response.use(function (response) {
    // dataAxios 是 axios 返回数据中的 data
    var dataAxios = response.data;
    // 这个状态码是和后端约定的
    var code = dataAxios.code;
    // 根据 code 进行判断
    if (code === undefined) {
      // 如果没有 code 代表这不是项目后端开发的接口 比如可能是 D2Admin 请求最新版本
      return dataAxios;
    } else {
      // 有 code 代表这是一个后端接口 可以进行进一步的判断
      switch (code) {
        case 200:
          // php
          return dataAxios;
        case 0:
          // python
          return dataAxios;
        case 4037:
          // python
          return dataAxios;
        case "xxx":
          // [ 示例 ] 其它和后台约定的 code
          errorCreate("[ code: xxx ] ".concat(dataAxios.msg, ": ").concat(response.config.url));
          break;
        case 60:
          errorCreate("\u63A5\u53E3\u5F02\u5E38\uFF0C\u8BF7\u91CD\u8BD5: ".concat(response.config.url));
        default:
          // 不是正确的 code
          errorCreate("".concat(dataAxios.msg, ": ").concat(response.config.url));
          break;
      }
    }
  }, function (error) {
    var status = get(error, "response.status");
    switch (status) {
      case 400:
        error.message = "请求错误";
        break;
      case 401:
        error.message = "未授权，请登录";
        break;
      case 403:
        error.message = "拒绝访问";
        break;
      case 404:
        error.message = "\u8BF7\u6C42\u5730\u5740\u51FA\u9519: ".concat(error.response.config.url);
        console.log(error.message);
        break;
      case 408:
        error.message = "请求超时";
        break;
      case 500:
        error.message = "服务器内部错误";
        break;
      case 501:
        error.message = "服务未实现";
        break;
      case 502:
        error.message = "网关错误";
        break;
      case 503:
        error.message = "服务不可用";
        break;
      case 504:
        error.message = "网关超时";
        break;
      case 505:
        error.message = "HTTP版本不受支持";
        break;
      default:
        break;
    }
    if (error.message !== "CANCELED") {
      errorLog(error);
    }
    return Promise.reject(error);
  });
  return service;
}

// 建议将配置抽离到单独的配置文件中
var API_CONFIG = {
  BASE_URLS: {
    LOCAL: "http://localhost:8090",
    HAN: "http://devhan.well-see.com",
    CONG: "http://devcong.well-see.com",
    DEV: "https://test.well-see.com",
    PRE: "https://pre.well-see.com",
    PROD_DEV: "https://prod.well-see.com",
    BASE_PROD: "https://www.wellcee.com",
    PROD: "https://walk-the-talk.well-see.com"
  },
  SIGN_KEY: "19E3BDE5A03AD42B3FD81347CFFDF50E",
  DEFAULT_TIMEOUT: 60000
};
export function getApiBaseUrl() {
  if (process.browser) {
    var _location = location,
      hostname = _location.hostname;
    var urlMap = {
      'localhost': API_CONFIG.BASE_URLS.DEV,
      'devcong.wellcee.com': API_CONFIG.BASE_URLS.CONG,
      'devhan.wellcee.com': API_CONFIG.BASE_URLS.HAN,
      'test.well-see.com': API_CONFIG.BASE_URLS.DEV,
      'pre.well-see.com': API_CONFIG.BASE_URLS.PRE,
      'prod.well-see.com': API_CONFIG.BASE_URLS.PROD_DEV,
      'walk-the-talk.well-see.com': API_CONFIG.BASE_URLS.BASE_PROD
    };
    return urlMap[hostname] || API_CONFIG.BASE_URLS.DEV;
  }
  return API_CONFIG.BASE_URLS.DEV;
}

/**
 * @description 创建请求方法
 * @param {Object} service axios 实例
 */
function createRequestFunction(service) {
  return function (config) {
    var javaApiSign = {};
    if (config.url.indexOf("/api/v3/") > -1) {
      var nonce = 123456;
      var timestamp = +new Date();
      var str = "" + timestamp + nonce + API_CONFIG.SIGN_KEY;
      var signature = window.btoa(md5(str));
      javaApiSign = {
        nonce: nonce,
        timestamp: timestamp,
        signature: signature
      };
    }
    var token = util.cookies.get("token");
    var configDefault = {
      headers: _objectSpread(_objectSpread({}, javaApiSign), {}, {
        Aid: util.cookies.get("aid") || '',
        Authorization: process.env.NODE_ENV == 'development' ? "power_auth" : '',
        "Content-Type": get(config, "headers.Content-Type", "application/json")
      }),
      timeout: API_CONFIG.DEFAULT_TIMEOUT,
      baseURL: getApiBaseUrl() || process.env.VUE_APP_API
    };
    return service(Object.assign(configDefault, config));
  };
}

// 用于真实网络请求的实例和请求方法
export var service = createService();
export var request = createRequestFunction(service);
export var apiBaseUrl = getApiBaseUrl();